<template>
  <hel-module title="品类采购占比" :class="scope.clsPrefix" v-loading="loading">
    <div class="chart-container">
      <div class="chart-main">
        <div class="chart-body-wrap">
          <div class="chart-center-text">
            <div class="center-value">{{ totalAmount }}万</div>
            <div class="center-label">{{ periodLabel }}</div>
          </div>
          <div id="categoryPurchaseChart" class="chart-body"></div>
        </div>
        <div class="legend-list">
          <div class="legend-item" v-for="(item, index) in categoryList" :key="index">
            <div class="item-header">
              <span class="item-dot" :style="{ background: item.color }"></span>
              <span class="item-name">{{ item.name }}</span>
            </div>
            <div class="item-value">{{ item.value }}万 · {{ item.percent }}%</div>
          </div>
        </div>
      </div>
    </div>
  </hel-module>
</template>

<script>
import HelModule from '../common/module/index.vue'
import * as echarts from 'echarts'
import { getCategoryProcurement } from '@/api/procurement'

export default {
  name: 'CategoryPurchaseProportion',
  components: {
    HelModule
  },
  props: {
    data: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      loading: false,
      scope: {
        clsPrefix: 'rvc-cosmoplat-workspace-category-proportion'
      },
      totalAmount: '--',
      periodLabel: '采购总额',
      categoryList: [],
      chartInstance: null
    }
  },
  mounted() {
    this.fetchData()
    window.addEventListener('resize', this.handleResize)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
    if (this.chartInstance) {
      this.chartInstance.dispose()
      this.chartInstance = null
    }
  },
  methods: {
    async fetchData() {
      this.loading = true
      try {
        const res = await getCategoryProcurement()
        if (!res || res.code !== 200 || !res.data) {
          this.categoryList = []
          this.totalAmount = '--'
          this.periodLabel = '采购总额'
          return
        }
        const data = res.data
        const colors = ['#6B7FD7', '#9BA5E8', '#C5CCEF']
        const items = Array.isArray(data.items) ? data.items : []
        this.categoryList = items.map((item, index) => ({
          name: item.categoryName,
          value: Number(item.amount) || 0,
          percent: item.percent,
          amount: Number(item.amount) || 0,
          color: colors[index % colors.length]
        }))
        this.totalAmount = data.totalAmount != null ? data.totalAmount : '--'
        if (data.statMonth) {
          const month = parseInt(data.statMonth.split('-')[1], 10)
          this.periodLabel = `${month}月总额`
        } else {
          this.periodLabel = '采购总额'
        }

        this.$nextTick(() => {
          this.drawChart()
        })
      } catch (error) {
        console.error('获取品类采购占比数据失败:', error)
        this.categoryList = []
        this.totalAmount = '--'
        this.periodLabel = '采购总额'
      } finally {
        this.loading = false
      }
    },
    drawChart() {
      const chart = echarts.init(
        document.getElementById('categoryPurchaseChart')
      )
      const option = {
        tooltip: {
          trigger: 'item',
          confine: true,
          formatter: (params) =>
            `${params.name}: ${params.value}万 (${params.percent}%)`
        },
        series: [
          {
            type: 'pie',
            radius: ['65%', '100%'],
            center: ['50%', '50%'],
            avoidLabelOverlap: false,
            hoverAnimation: false,
            label: {
              show: false,
              position: 'center'
            },
            labelLine: {
              show: false
            },
            data: this.categoryList.map((item) => ({
              value: item.amount,
              name: item.name,
              itemStyle: {
                color: item.color
              }
            }))
          }
        ]
      }
      chart.setOption(option)
      this.chartInstance = chart
      this.$nextTick(() => {
        requestAnimationFrame(() => {
          this.chartInstance && this.chartInstance.resize()
        })
        setTimeout(() => {
          this.chartInstance && this.chartInstance.resize()
        }, 200)
      })
    },
    handleResize() {
      if (this.chartInstance) {
        setTimeout(() => {
          this.chartInstance.resize()
        }, 200)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
$class-prefix: "rvc-cosmoplat-workspace-category-proportion";
.#{$class-prefix} {
  .chart-container {
    height: 100%;
    display: flex;
    flex-direction: column;
    padding: 10px 0;
    box-sizing: border-box;
  }
  .chart-main {
    flex: 1;
    display: flex;
    align-items: center;
    min-height: 0;
  }
  .chart-body-wrap {
    position: relative;
    width: 55%;
    height: 100%;
    min-height: 220px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .chart-center-text {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
    z-index: 1000;
    .center-label {
      font-family: PingFangSC-Medium;
      font-weight: 600;
      font-size: 11px;
      color: #333333;
    }
    .center-value {
      font-size: 18px;
      font-weight: 700;
      color: #333;
    }
  }
  .chart-body {
    width: 100%;
    height: 100%;
    min-height: 220px;
  }
  .legend-list {
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 14px;
    padding-left: 12px;
    flex-shrink: 0;
    min-width: 40%;
  }
  .legend-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .item-header {
    display: flex;
    align-items: center;
    gap: 8px;
  }
  .item-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
  }
  .item-name {
    font-size: 12px;
    color: #666666;
    font-weight: 400;
  }
  .item-value {
    font-size: 12px;
    color: #333333;
    font-weight: 600;
  }
}
</style>
